import React, { useState } from 'react';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TextField from "../../Forms/TextField";
import ImagePreviewUpload from '../../Util/ImagePreviewUpload';
import { Image, Stack } from "@fluentui/react";
import { useFormikContext } from "formik";
import ImageGallery from '../../Forms/ImageGallery';

const helpContainerCss = css`
    display: flex;
    align-items: end;
    gap: 6px;
    width: 100%;
    margin-bottom: 10px;
`;

const ImageUploadStep = ({ options }) => {
  const { values, setFieldValue } = useFormikContext();
  const [showHelp, setShowHelp] = useState(false);
  const gallery = options?.gallery;
  const standard = options?.standard;

  return (
    <Stack>
      <div css={helpContainerCss}>
        <div css={css`flex-grow: 1;`}>
          <TextField
            fullWidth
            label={options.label}
            name={options.name}
            required={options.required}
          />
        </div>
        {options.showHelpIcon && (
          <HelpOutlineIcon
            onClick={() => setShowHelp(!showHelp)}
            style={{
              fontSize: 32,
              color: 'var(--Z8)',
              cursor: 'pointer',
              flexShrink: 0,
            }}
        />
        )}
      </div>
      {options.helpMsg && (
        (options.showHelpIcon ? showHelp : true) && (
          <label className="preview-upload-help">{options.helpMsg}</label>
        )
      )}

      {options.previewUrl && (
        <Image className="preview-image" src={options.previewUrl} width={options.width} height={options.height} />
      )}

      {gallery && (
        <ImageGallery
          setFieldValue={setFieldValue}
          fieldName={gallery.name}
          blobUrl={gallery.blobUrl}
          containerName={gallery.containerName}
          folderName={gallery.folderName}
          imageUrl={gallery.imageUrl}
          heading={gallery.heading}
          btnText={gallery.btnText}
          sizePathGroup={gallery.sizePathGroup}
        />
      )}

      {standard && (
        <ImagePreviewUpload
          id={values[standard.id] || standard.id} 
          idType={standard.idType}
          cdnPath={standard.cdnPath}
          cdnUrl={standard.cdnUrl}
          uploadUrl={standard.uploadUrl}
          previewUrl={values[standard.previewUrl] || ''}
          name={standard.name}
          label={standard.label}
          width={standard.width}
          height={standard.height}
          helpMsg={standard.helpMsg}
          btnText={standard.btnText}
        />
      )}
    </Stack>
  );
};

export default ImageUploadStep;
